import { render } from "./CustomersOrderList.vue?vue&type=template&id=133f4b6f&scoped=true&ts=true"
import script from "./CustomersOrderList.vue?vue&type=script&lang=ts"
export * from "./CustomersOrderList.vue?vue&type=script&lang=ts"

import "./CustomersOrderList.vue?vue&type=style&index=0&id=133f4b6f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133f4b6f"]])

export default __exports__